module.exports = __webpack_public_path__ + "img/right-icon.06577a42.svg";